import type { MinistriesType } from '../ministry';
import { getSheetByMinistry, getSpecificMinistryFiles } from './get-sheet';

const TARGET_YEAR = '2025';
// コメントアウトは以降のPRで解消される
export const MINISTRIES_2025: MinistriesType[] = [
  getSheetByMinistry({
    ministry: 'cabinet-secretariat-cabinet-office',
    formatsType: 'customFormats',
    customFormats: (ministry) => [
      ...getSpecificMinistryFiles({
        year: TARGET_YEAR,
        // 内閣官房
        ministry,
        specificMinistry: 'cabinet-secretariat',
        formats: ['rsFormat1', 'rsFormat2', 'rsFormat4'],
      }),
      ...getSpecificMinistryFiles({
        year: TARGET_YEAR,
        // 内閣府
        ministry: 'cabinet-office',
        specificMinistry: 'cabinet-office',
        formats: [
          'rsFormat1',
          'rsFormat2',
          'rsFormat3',
          'rsFormat4',
          'ks',
          'ksInvestment',
          'ksLocalGovernmentA',
          'ksLocalGovernmentB',
        ],
      }),
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 公正取引委員会
    ministry: 'fair-trade-commission',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 警察庁
    ministry: 'national-police-agency',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat3', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 個人情報保護委員会
    ministry: 'personal-information-protection-commission',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // カジノ規制委員会
    ministry: 'casino-regulatory-commission',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 金融庁
    ministry: 'financial-services-agency',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat2', 'rsFormat3', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 消費者庁
    ministry: 'consumer-affairs-agency',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat3', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // こども家庭庁
    ministry: 'children-and-families-agency',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // デジタル庁
    ministry: 'digital-agency',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat2', 'rsFormat3', 'rsFormat4'],
  }),

  getSheetByMinistry({
    year: TARGET_YEAR,
    // 復興庁
    ministry: 'reconstruction-agency',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
      'ksInvestment',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 総務省
    ministry: 'ministry-of-internal-affairs-and-communications',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 法務省
    ministry: 'ministry-of-justice',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat3', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 外務省
    ministry: 'ministry-of-foreign-affairs',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 財務省
    ministry: 'ministry-of-finance',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat2', 'rsFormat3', 'rsFormat4', 'ks'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 文部科学省
    ministry: 'ministry-of-education-culture-sports-science-and-technology',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 厚生労働省
    ministry: 'ministry-of-health-labour-and-welfare',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),

  getSheetByMinistry({
    year: TARGET_YEAR,
    // 農林水産省
    ministry: 'ministry-of-agriculture-forestry-and-fisheries',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 経済産業省
    ministry: 'ministry-of-economy-trade-and-industry',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 国土交通省
    ministry: 'ministry-of-land-infrastructure-and-transport',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksInvestment',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 環境省
    ministry: 'ministry-of-the-environment',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
      'ksInvestment',
    ],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 原子力規制委員会
    ministry: 'nuclear-regulation-authority',
    formatsType: 'formats',
    formats: ['rsFormat1', 'rsFormat2', 'rsFormat3', 'rsFormat4'],
  }),
  getSheetByMinistry({
    year: TARGET_YEAR,
    // 防衛省
    ministry: 'ministry-of-defense',
    formatsType: 'formats',
    formats: [
      'rsFormat1',
      'rsFormat2',
      'rsFormat3',
      'rsFormat4',
      'ks',
      'ksLocalGovernmentA',
      'ksLocalGovernmentB',
    ],
  }),
];
